import { Fragment, useEffect, useRef } from 'react'

export function Resizer() {
  const isSp = useRef(false)

  useEffect(() => {
    isSp.current = window.innerWidth < 744

    const resize = () => {
      const isSpImmediately = window.innerWidth < 744

      if (isSpImmediately !== isSp.current) {
        window.location.reload()
      }

      isSp.current = isSpImmediately
    }

    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return <Fragment />
}
